var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import union from 'lodash/union';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import PageConfig from '@nomady/shared/routeConfiguration/Page';
import routeConfiguration from '@nomady/shared/routeConfiguration/routeConfiguration';
import { pathByRouteName } from '@nomady/shared/utils/routes';
import { getDeeplLocale } from '@nomady/shared/marketplace-custom-config';
import { CampCategory } from '@nomady/shared/types';
import { Share } from '@capacitor/share';
import { getMarketplaceEntities } from '../../../ducks/marketplaceData.duck';
import { localeSelector, ModalId, setLastOpenModal, } from '../../../slices/UISlice';
import AddToFavoritesModal from '../../../styled-components/AddToFavoritesModal';
import Avatar from '../../../styled-components/Avatar/Avatar';
import LikeButton, { LikeButtonColorVariant, } from '../../../styled-components/LikeButton/LikeButton';
import Text, { TextVariant } from '../../../styled-components/Text/Text';
import { ColorVariant } from '../../../theme';
import Icon, { IconSizeVariant, IconVariant, } from '../../../styled-components/Icon/Icon';
import ReviewRating from '../../../styled-components/Review/ReviewRating';
import TranslatedBy from '../../../styled-components/TranslatedBy/TranslatedBy';
import ToggleTranslationButton from '../../../styled-components/ToggleTranslationButton/ToggleTranslationButton';
import { ListingContentModalVariant, toggleTranslation, } from '../ListingPageSlice';
import getLocationInformation from '../../../util/addressHelpers';
import Modal from '../../../styled-components/Modal/Modal';
import CampStyleDetailsContent from '../ModalContents/CampStyleDetailsContent';
import InstantBookingContent from '../ModalContents/InstantBookingContent';
import VerifiedListingContent from '../ModalContents/VerifiedListingContent';
import campStyleIcons from '../../../campStyleIcons';
import IconButton, { IconButtonColorVariant, IconButtonSizeVariant, } from '../../../styled-components/IconButton/IconButton';
import { isApp } from '../../../util/deviceContext';
import { SnackBarType, addSnackBar, } from '../../../components/SnackBar/SnackBarSlice';
import ListingCardBadge from '../../../styled-components/ListingCard/components/ListingCardBadge';
const EXCERPT_LENGTH = 400;
const IntroSectionWrap = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 25px;
`;
const HostInfoAndFavoriteButton = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: initial;
  justify-content: space-between;
  width: 100%;
  @media ${props => props.theme.device.tablet} {
    position: absolute;
    top: -80px;
    padding-left: 30px;
    width: 100%;
  }
`;
const HostPreview = styled.div `
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
`;
const OutlinedAvatarContainer = styled.div `
  height: fit-content;
  width: fit-content;
  @media ${props => props.theme.device.tablet} {
    border-radius: 50%;
    border: 2px solid ${props => props.theme.color.pearl};
  }
`;
const HostName = styled(Text) `
  @media ${props => props.theme.device.tablet} {
    margin-top: 25px;
    min-width: 300px;
  }
`;
const LikeButtonContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${props => props.theme.device.tablet} {
    margin-top: 25px;
  }
`;
const ListingLabel = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 12px;
  gap: 4px;
  height: 22px;
  border-radius: 5px;
  color: ${props => props.theme.color.pearl};
  background: ${props => props.theme.color[props.backgroundColor]};
  cursor: pointer;
`;
const ReviewPreview = styled.div `
  display: flex;
  height: 26px;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const LocationPreview = styled.div `
  display: flex;
  height: 22px;
  align-items: center;
  cursor: pointer;
`;
const CampStylePreview = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 8px 0 12px;
  gap: 8px;
  height: 38px;
  width: fit-content;
  background: ${props => props.theme.color.pearl};
  border-radius: 10px;
  cursor: pointer;
`;
const HeadWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 0;
  @media ${props => props.theme.device.tablet} {
    margin-top: 30px;
  }
`;
const NameAndBadgesWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: fit-content;
`;
const MiddleSectionWrap = styled.div `
  display: flex;
  gap: 8px;
`;
const ReviewText = styled(Text) `
  display: none;
  @media ${props => props.theme.device.tabletL} {
    display: initial;
  }
`;
const TranslationSection = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0 10px 0;
`;
const ListingDescriptionSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 7px;
  white-space: break-spaces;
`;
const ExpandDescriptionButton = styled.button `
  width: fit-content;
  outline: none;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  text-decoration: none;
  border-bottom: 1px solid ${props => props.theme.color.cave};
  cursor: pointer;
`;
const IntroSection = ({ onClickHostPreview, onClickAverageReview, onClickLocationReview }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    const intl = useIntl();
    const [isCampStyleModalOpen, setIsCampStyleModalOpen] = useState(false);
    const [isVerifiedModalOpen, setIsVerifiedModalOpen] = useState(false);
    const [isInstanBookingModalOpen, setIsInstanBookingModalOpen] = useState(false);
    const state = useSelector((state) => state);
    const [showFavoritesBottomSheet, setShowFavoritesBottomSheet] = useState(false);
    const [showEntireDescription, setShowEntireDescription] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const locale = useSelector(localeSelector);
    const { isAuthenticated } = state.Auth;
    const { provider, listing, reviewsPagination, translationActive } = state.ListingPage;
    if (!provider || !listing) {
        return null;
    }
    let profileImage;
    if ((_c = (_b = (_a = provider === null || provider === void 0 ? void 0 : provider.relationships) === null || _a === void 0 ? void 0 : _a.profileImage) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id) {
        profileImage = getMarketplaceEntities(state, [
            provider.relationships.profileImage.data,
        ]);
    }
    const redirectToLoginPage = (listingId, history) => {
        const path = pathByRouteName(PageConfig.Login, routeConfiguration);
        const payload = {
            modalId: ModalId.AddToFavorites,
            metaData: Object.assign(Object.assign({}, listingId), { backUrl: undefined }),
        };
        dispatch(setLastOpenModal(payload));
        history.push(path);
    };
    const liked = union(...(((_d = state.listingFavoritesLists) === null || _d === void 0 ? void 0 : _d.listingFavoritesLists) || []).map(list => list.listings)).includes(listing.id.uuid);
    const openFavoritesBottomSheet = () => {
        if (isAuthenticated) {
            setShowFavoritesBottomSheet(true);
        }
        else {
            redirectToLoginPage(listing.id, history);
        }
    };
    // eslint-disable-next-line camelcase
    const { address_components } = ((_f = (_e = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _e === void 0 ? void 0 : _e.publicData) === null || _f === void 0 ? void 0 : _f.location) || {};
    const { totalReviews } = reviewsPagination;
    const reviewsText = `${intl.formatMessage({
        id: 'ListingPage.reviews',
    }, {
        totalReviews,
    })}`;
    const { instantBookingAvailable } = ((_g = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _g === void 0 ? void 0 : _g.publicData) || {};
    const { isVerified } = ((_h = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _h === void 0 ? void 0 : _h.metadata) || {};
    const isAccommodation = ((_k = (_j = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _j === void 0 ? void 0 : _j.publicData) === null || _k === void 0 ? void 0 : _k.category) === CampCategory.accommodation;
    const showWinter = ((_m = (_l = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _l === void 0 ? void 0 : _l.publicData) === null || _m === void 0 ? void 0 : _m.winterCapability) &&
        ((_p = (_o = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _o === void 0 ? void 0 : _o.publicData) === null || _p === void 0 ? void 0 : _p.descriptionWinterEnabled);
    const season = showWinter ? 'winter' : 'summer';
    const { originalLocale, translatedBy } = ((_q = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _q === void 0 ? void 0 : _q.publicData) || {};
    const translatable = originalLocale && originalLocale !== getDeeplLocale(locale);
    const showTranslatedByLabel = translationActive && originalLocale && translatedBy;
    const description = (_v = (_u = (_t = (_s = (_r = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _r === void 0 ? void 0 : _r.publicData) === null || _s === void 0 ? void 0 : _s.localizedPublicData) === null || _t === void 0 ? void 0 : _t.seasons) === null || _u === void 0 ? void 0 : _u[season]) === null || _v === void 0 ? void 0 : _v.description;
    const excerpt = description &&
        `${description === null || description === void 0 ? void 0 : description.slice(0, EXCERPT_LENGTH)}${EXCERPT_LENGTH < description.length ? '...' : ''}`;
    const showMoreButton = description && EXCERPT_LENGTH < description.length;
    const handleSharing = () => __awaiter(void 0, void 0, void 0, function* () {
        const campaignSource = 'app';
        const campaignMedium = 'share';
        const campaignName = 'listing_share';
        const campaignContent = `listing_${listing.id.uuid}`;
        const sharableUrl = `https://nomady.camp/l/${listing.id.uuid}?utm_source=${encodeURIComponent(campaignSource)}&utm_medium=${encodeURIComponent(campaignMedium)}&utm_campaign=${encodeURIComponent(campaignName)}&utm_content=${encodeURIComponent(campaignContent)}`;
        if (isApp) {
            try {
                yield Share.share({
                    title: listing.attributes.title,
                    url: sharableUrl,
                    dialogTitle: intl.formatMessage({
                        id: 'ListingPage.sharingDialogTitle',
                    }),
                });
            }
            catch (error) {
                copyCabinLinkIntoClipboard(sharableUrl);
                console.error("Couldn't share cabin", error);
            }
        }
        else {
            const shareData = {
                title: listing.attributes.title,
                text: intl.formatMessage({
                    id: 'ListingPage.sharingDialogTitle',
                }),
                url: sharableUrl,
            };
            if (navigator.canShare && navigator.canShare(shareData)) {
                try {
                    yield navigator.share(shareData);
                }
                catch (e) {
                    console.error('Sharing failed', e);
                    copyCabinLinkIntoClipboard(sharableUrl);
                }
            }
            else {
                copyCabinLinkIntoClipboard(sharableUrl);
            }
        }
    });
    const copyCabinLinkIntoClipboard = (url) => {
        try {
            navigator.clipboard.writeText(url);
            dispatch(addSnackBar({
                type: SnackBarType.SUCCESS,
                i18nTitleKey: 'ListingPage.sharingCopySuccess',
            }));
        }
        catch (e) {
            dispatch(addSnackBar({
                type: SnackBarType.ERROR,
                i18nTitleKey: 'ListingPage.sharingCopyError',
            }));
        }
    };
    return (_jsxs(IntroSectionWrap, { children: [_jsxs(HeadWrapper, { children: [_jsxs(HostInfoAndFavoriteButton, { children: [_jsx("div", Object.assign({ onClick: onClickHostPreview }, { children: _jsxs(HostPreview, { children: [_jsx(OutlinedAvatarContainer, { children: _jsx(Avatar, { source: profileImage &&
                                                    profileImage[0].attributes.variants['square-small2x'].url }) }), _jsxs(NameAndBadgesWrapper, { children: [_jsxs(HostName, Object.assign({ variant: TextVariant.H51, colorVariant: ColorVariant.Stone }, { children: [(_x = (_w = provider === null || provider === void 0 ? void 0 : provider.attributes) === null || _w === void 0 ? void 0 : _w.profile) === null || _x === void 0 ? void 0 : _x.displayName, "."] })), ((_0 = (_z = (_y = provider === null || provider === void 0 ? void 0 : provider.attributes) === null || _y === void 0 ? void 0 : _y.profile) === null || _z === void 0 ? void 0 : _z.metadata) === null || _0 === void 0 ? void 0 : _0.isTopHost) && (_jsx(ListingCardBadge, { iconVariant: IconVariant.Tophost, labelId: "ListingCard.topHost", backgroundColorVariant: ColorVariant.BasicPearlWhiteTypeWhite }))] })] }) })), _jsxs(LikeButtonContainer, { children: [_jsx(LikeButton, { dataTestId: "IntroSection_LikeButton", liked: liked, onClick: openFavoritesBottomSheet, colorVariant: LikeButtonColorVariant.Pearl, label: intl.formatMessage({ id: 'ListingPage.favoritesButton' }) }), _jsx(IconButton, { iconVariant: IconVariant.Share, colorVariant: IconButtonColorVariant.Light, iconButtonSizeVariant: IconButtonSizeVariant.Small, onClick: handleSharing })] })] }), _jsx(AddToFavoritesModal, { open: showFavoritesBottomSheet, onClose: () => setShowFavoritesBottomSheet(false), listingId: listing.id })] }), _jsx(Text, Object.assign({ as: "h1", colorVariant: ColorVariant.Cave, variant: TextVariant.H20 }, { children: (_1 = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _1 === void 0 ? void 0 : _1.title })), _jsxs(LocationPreview, Object.assign({ onClick: onClickLocationReview }, { children: [_jsx(Icon, { variant: IconVariant.SimplePin, sizeVariant: IconSizeVariant.ExtraSmall, colorVariant: ColorVariant.Stone }), _jsx(Text, Object.assign({ variant: TextVariant.B30, colorVariant: ColorVariant.Stone }, { children: getLocationInformation(address_components) }))] })), _jsxs(MiddleSectionWrap, { children: [_jsxs(ReviewPreview, Object.assign({ onClick: onClickAverageReview }, { children: [_jsx(ReviewRating, { rating: (_3 = (_2 = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _2 === void 0 ? void 0 : _2.metadata) === null || _3 === void 0 ? void 0 : _3.rating }), totalReviews > 0 && (_jsxs(Text, Object.assign({ variant: TextVariant.B50 }, { children: [`(`, totalReviews, _jsx(ReviewText, Object.assign({ variant: TextVariant.B50 }, { children: ` ${reviewsText}` })), `)`] })))] })), !!isVerified && (_jsxs(ListingLabel, Object.assign({ backgroundColor: ColorVariant.Moss, onClick: () => {
                            setIsVerifiedModalOpen(true);
                        } }, { children: [_jsx(Icon, { sizeVariant: IconSizeVariant.ExtraExtraSmall, variant: IconVariant.Checkmark, colorVariant: ColorVariant.Pearl }), _jsx(Text, Object.assign({ variant: TextVariant.H13, colorVariant: ColorVariant.Pearl }, { children: intl.formatMessage({
                                    id: 'ListingCard.verified',
                                }) })), _jsx(Modal, Object.assign({ id: `ListingModal_${ListingContentModalVariant.VERIFIED}`, onClose: () => setIsVerifiedModalOpen(false), isOpen: isVerifiedModalOpen, title: intl.formatMessage({ id: 'ListingPage.verified' }) }, { children: _jsx(VerifiedListingContent, {}) }))] }))), !!instantBookingAvailable && (_jsxs(ListingLabel, Object.assign({ "data-testid": "IntroSection_InstantBookingLabel", backgroundColor: ColorVariant.Cave, onClick: () => {
                            setIsInstanBookingModalOpen(true);
                        } }, { children: [_jsx(Icon, { sizeVariant: IconSizeVariant.ExtraExtraSmall, variant: IconVariant.Flash, colorVariant: ColorVariant.Pearl }), _jsx(Text, Object.assign({ variant: TextVariant.H13, colorVariant: ColorVariant.Pearl }, { children: intl.formatMessage({
                                    id: 'ListingCard.instantBooking',
                                }) })), _jsx(Modal, Object.assign({ id: `ListingModal-${ListingContentModalVariant.INSTANT_BOOKING}`, onClose: () => setIsInstanBookingModalOpen(false), isOpen: isInstanBookingModalOpen, title: intl.formatMessage({ id: 'ListingPage.instantBooking' }) }, { children: _jsx(InstantBookingContent, {}) }))] })))] }), _jsxs(CampStylePreview, Object.assign({ onClick: () => setIsCampStyleModalOpen(true) }, { children: [_jsx(Text, Object.assign({ "data-testid": "IntroSection_ListingTypeTag", variant: TextVariant.B30, colorVariant: ColorVariant.Cave }, { children: !isAccommodation
                            ? intl.formatMessage({ id: 'ListingPage.campStyle' })
                            : intl.formatMessage({
                                id: 'MarketplaceConfig.accommodation',
                            }) })), (_6 = (_5 = (_4 = listing === null || listing === void 0 ? void 0 : listing.attributes) === null || _4 === void 0 ? void 0 : _4.publicData) === null || _5 === void 0 ? void 0 : _5.campStyle) === null || _6 === void 0 ? void 0 : _6.map(campStyle => (_jsx(Icon, { variant: campStyleIcons[campStyle] }, `icon-${campStyle}`))), _jsx(Modal, Object.assign({ id: `ListingModal-${ListingContentModalVariant.CAMP_STYLE_DETAILS}`, onClose: () => setIsCampStyleModalOpen(false), isOpen: isCampStyleModalOpen, title: intl.formatMessage({
                            id: isAccommodation
                                ? 'ListingPage.accommodationSuitableFor'
                                : 'ListingPage.campStyleTitle',
                        }) }, { children: _jsx(CampStyleDetailsContent, {}) }))] })), _jsxs(ListingDescriptionSection, { children: [description && (_jsx(Text, Object.assign({ as: "p" }, { children: showEntireDescription ? description : excerpt }))), _jsxs(TranslationSection, { children: [originalLocale && translatable && (_jsx(ToggleTranslationButton, { active: translationActive, onClick: () => dispatch(toggleTranslation(listing === null || listing === void 0 ? void 0 : listing.id, false)) })), showTranslatedByLabel && (_jsx(TranslatedBy, { translatedBy: translatedBy, originalLocale: originalLocale }))] }), showMoreButton && (_jsx(ExpandDescriptionButton, Object.assign({ onClick: () => setShowEntireDescription(!showEntireDescription) }, { children: intl.formatMessage({
                            id: showEntireDescription
                                ? 'ListingPage.showLess'
                                : 'ListingPage.showMore',
                        }) })))] })] }));
};
export default IntroSection;
